import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import EntityEditPageSkeleton from 'components/EntityEditPageSkeleton';
import PageWithSidebar from 'components/PageWithSidebar';
import RoomSidebar from 'components/RoomSidebar';
import RoomEditTabs from 'components/RoomEditTabs';
import NotFound from 'components/NotFound';

import { withData } from 'lib';
import { RoomEditPageQuery } from '__generated__/RoomEditPageQuery.graphql';

const query = graphql`
  query RoomEditPageQuery($id: ID!) {
    room(id: $id) {
      nameString

      hotel {
        id
        name
      }

      ...RoomEditTabs_room
      ...RoomSidebar_room
    }

    ...RoomEditTabs_data
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<RoomEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [{ link: '/hotels', name: 'Viešbučiai' }];

const RoomEditPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<RoomEditPageQuery>(query, preloadedQuery);
  const { room } = data;

  if (!room) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<RoomSidebar room={room} />}
      breadcrumbs={[
        ...breadcrumbs,
        { link: `/hotels/${room.hotel.id}`, name: room.hotel.name },
        { name: room.nameString ?? 'Kambarys' },
      ]}>
      <RoomEditTabs room={room} data={data} />
    </PageWithSidebar>
  );
};

export default withData<RoomEditPageQuery, RouteParams>({
  query,
  loading: <EntityEditPageSkeleton breadcrumbs={breadcrumbs} />,

  variables: ({ routeParams }) => ({
    id: routeParams.id,
  }),
})(RoomEditPage);
